module.exports = __webpack_public_path__ + "static/media/veona-premium-package.03cf0568.png";